import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const Theme = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#fde8eb',  // tom claríssimo (hover suave)
      100: '#f8ccd2',
      200: '#f29da9',
      300: '#ec6f80',
      400: '#e64057',
      500: '#C8102E',  // 🔴 vermelho institucional SSP / Governo SP
      600: '#b00e29',
      700: '#970c23',
      800: '#7e0a1d',
      900: '#660818',
      950: '#4d0612'
    },
    surface: {
      0:  '#ffffff',
      50: '#f7f7f7',
      100: '#ededed',
      200: '#d9d9d9',
      300: '#b3b3b3',
      400: '#8c8c8c',
      500: '#666666',
      600: '#4d4d4d',
      700: '#333333',
      800: '#1e1e1e',  // ⚫ cinza-escuro institucional (background padrão)
      900: '#0f0f0f'
    },
    accent: {
      100: '#E5E5E5',
      200: '#A0A0A0',
      300: '#3C3C3C'
    },
    neutral: {
      0: '#ffffff',
      900: '#1E1E1E'
    },
    focusRing: {
      color: '#C8102E33' // vermelho translúcido para foco de input
    }
  },
  components: {
    button: {
      primary: {
        background: '{primary.500}',
        color: '#ffffff',
        hoverBackground: '{primary.600}',
        activeBackground: '{primary.700}',
        border: 'none',
        borderRadius: '9999px',
        fontWeight: '500'
      }
    }
  }
});